/**
 * 問い合わせフォーム: Pattern Select を監視セレクトの値に応じて表示/非表示
 */
// SvelteとShopifyのデータをやり取りするための関数
var product_additional_options = {
  waterRepellent: null,
  embroidery: null,
  hanakomon: null,
  patterns: null,
};


function initPatternSelectConditionalVisibility() {
  const wrappers = document.querySelectorAll('.pattern-select-condition-wrapper[data-watch-input-name][data-display-when-values]');
  if (!wrappers.length) return;

  function parseValues(str) {
    if (!str || typeof str !== 'string') return [];
    return str.split('|||').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function toggleWrapper(wrapper, show) {
    wrapper.style.display = show ? '' : 'none';
  }

  function findInputByName(name) {
    const inputs = document.querySelectorAll('#ContactForm input[type="hidden"]');
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('name') === name) return inputs[i];
    }
    return null;
  }

  function checkInput(wrapper) {
    const inputName = wrapper.getAttribute('data-watch-input-name');
    const valuesStr = wrapper.getAttribute('data-display-when-values');
    const allowedValues = parseValues(valuesStr);
    const input = findInputByName(inputName);
    if (!input) return;
    const val = (input.value || '').trim();
    const show = allowedValues.indexOf(val) !== -1;
    toggleWrapper(wrapper, show);
  }

  wrappers.forEach(function (wrapper) {
    const inputName = wrapper.getAttribute('data-watch-input-name');
    const input = findInputByName(inputName);
    if (!input) return;

    checkInput(wrapper);

    input.addEventListener('change', function () { checkInput(wrapper); });
    input.addEventListener('input', function () { checkInput(wrapper); });
  });

  var form = document.getElementById('ContactForm');
  if (form) {
    form.addEventListener('click', function () {
      setTimeout(function () {
        wrappers.forEach(function (wrapper) {
          var inputName = wrapper.getAttribute('data-watch-input-name');
          if (findInputByName(inputName)) checkInput(wrapper);
        });
      }, 100);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPatternSelectConditionalVisibility);
} else {
  initPatternSelectConditionalVisibility();
}

/**
 * Pattern情報の整形
 */
function formatPatternData(option, productCount) {
  console.log('formatPatternData', option);
  let patternName = '';
  patternName = option.patterns[0];
  if (option.patterns.length > 1) {
    patternName += ' / ' + option.patterns[1];
  }
  const inputData = [];
  if (option.designType != 'none') {
    inputData.push({
      name: productCount > 1 ? `${option.name} Design` : `Design`,
      value: option.designType
    });
  }
  inputData.push({
    name: productCount > 1 ? `${option.name} Color` : `Color`,
    value: patternName
  });
  return {
    inputData: inputData,
    patternName: patternName
  };
}

/**
 * svelte側から Shopify の header を操作するための関数
 */
const headerSection = document.querySelector('.header-section');
const headerGroup = document.querySelector('.shopify-section-group-header-group');
const drawer = document.querySelector('.drawer');
const drawerOverlay = document.querySelector('.drawer-overlay');
const contactForm = document.querySelector('.shopify-section.contact-form');
const footerInput = document.querySelector('.newsletter-footer .newsletter-footer--wrapper .input-group');
const footerBottom = document.querySelector('.footer-bottom');

function setHeaderSticky() {
  headerSection.style.display = 'block';
  headerGroup.style.display = 'block';
  contactForm.style.position = 'static';
  footerInput.style.display = 'flex';
  footerBottom.style.display = 'block';
}
function setHeaderUnSticky() {
  headerSection.style.display = 'none';
  headerGroup.style.display = 'none';
  contactForm.style.position = 'fixed';
  contactForm.style.top = '0';
  contactForm.style.left = '0';
  footerInput.style.display = 'none';
  footerBottom.style.display = 'none';
}

/**
 * 商品ページのオプションを登録する関数
 */
const PRODUCT_PROPERTIES = [];
function registerOption(option) {
  const addProperties = product_additional_options[option.type] === null;
  product_additional_options[option.type] = option;

  let inputData = [];
  let isValidate = null;
  if (option.type === 'patterns') {
    option.values.forEach(value => {
      const data = formatPatternData(value, option.values.length);
      inputData.push(...data.inputData);
    });
    isValidate = option.validate;
    const patternSelecter = document.getElementById('product-pattern-selecter');
    if (patternSelecter) {
      patternSelecter.dataset.validate = isValidate;
    }
    console.log('inputData', inputData);

  }
  // inputData から input を作成
  const form = document.querySelector('#ContactForm');
  inputData.forEach(data => {
    const input = form.querySelector(`input[name="contact[fabric samples]"]`);
    // 既にある場合は値を更新し、ない場合は新規に作成
    if (input) {
      if (data.value === null) {
        input.remove();
      } else {
        input.value = data.value;
        // PRODUCT_PROPERTIES.find(p => p.name === data.name).value = data.value;
      }
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `contact[fabric samples]`;
      input.value = data.value;
      form.appendChild(input);
      PRODUCT_PROPERTIES.push(data);
    }
  });
  if (option.type === 'patterns') {
    window.dispatchEvent(
      new CustomEvent("patternSelecteChanged", {
        detail: {
          values: option.values
        },
      }),
    );
  }
}

/**
 * オプションのバリデーション
 */

// Svelteアプリからの値を取得するリスナー
window.addEventListener('svelteTargetCartItemChanged', function (event) {
  const { selectedCartItem, selectedPatterns } = event.detail;

  console.log('Svelteから取得した値:', {
    selectedCartItem,
    selectedPatterns
  });

  // ここで取得した値を使用して何か処理を行う
  // 例: フォームに値を設定する
  if (selectedPatterns && selectedPatterns.length > 0) {
    // フォームフィールドに値を設定
    const patternInput = document.querySelector('input[name="pattern_selection"]');
    if (patternInput) {
      patternInput.value = JSON.stringify(selectedPatterns);
    }
  }
});
